import { createTheme } from '@mui/material/styles';
import type {} from '@mui/x-data-grid/themeAugmentation';
import style from './style.module.scss';

const theme = createTheme({
    palette: {
        primary: {
            main: style.primaryColor,
            contrastText: '#fff',
        },
        secondary: {
            main: style.secondaryColor,
            contrastText: '#fff',
        },
        success: {
            main: style.successColor,
            contrastText: '#fff',
        },
        error: {
            main: style.errorColor,
            contrastText: '#fff',
        },
        warning: {
            main: style.warningColor,
            contrastText: '#fff',
        },
    },
    typography: {
        fontFamily: ['Nunito', 'Noto Sans TC'].join(','),
    },
    components: {
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    // backgroundColor: 'red',
                    // color: 'blue',
                },
            },
        },
    },
    mixins: {
        MuiDataGrid: {
            // Headers, and top & bottom fixed rows
            containerBackground: style.lightBlueColor2,
        },
    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 577,
            md: 769,
            lg: 993,
            xl: 1201,
        },
    },
});

export default theme;
